var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMentorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.667 2.91602C14.8097 2.91602 16.3811 2.91602 17.3573 3.95335C18.3337 4.99067 18.3337 6.66023 18.3337 9.99935C18.3337 13.3384 18.3337 15.008 17.3573 16.0453C16.3811 17.0827 14.8097 17.0827 11.667 17.0827H8.33366C5.19096 17.0827 3.61962 17.0827 2.6433 16.0453C1.66699 15.008 1.66699 13.3384 1.66699 9.99935C1.66699 6.66023 1.66699 4.99067 2.6433 3.95335C3.61962 2.91602 5.19096 2.91602 8.33366 2.91602H11.667Z",
    stroke: "black",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.16699 12.9172C5.50753 11.1361 8.62858 11.0389 10.0003 12.9172M8.54116 8.5423C8.54116 9.34772 7.88826 10.0006 7.08284 10.0006C6.27743 10.0006 5.62451 9.34772 5.62451 8.5423C5.62451 7.7369 6.27743 7.08398 7.08284 7.08398C7.88826 7.08398 8.54116 7.7369 8.54116 8.5423Z",
    stroke: "black",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 7.91602H15.8333",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 11.25H14.1667",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMentorIcon);
export default __webpack_public_path__ + "static/media/mentor-icon.7ac383701f98a5410aa875b9c49c3785.svg";
export { ForwardRef as ReactComponent };